import { faVial } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { addRegressionTest } from 'features/BillOfMaterials/store/asyncActions/addRegressionTest'
import { BomItemMenuItem } from './BomItemMenuItem'

export const RegressionTestMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  if (process.env.REACT_APP_ENVIRONMENT === 'prd') {
    return null
  }

  return (
    <BomItemMenuItem
      action={addRegressionTest}
      actionParams={{ bomItemId }}
      primaryTextTranslationKey="project:regression-test"
      secondaryTextTranslationKey="project:regression-test-description"
      icon={
        <FontAwesomeIcon
          className="MuiSvgIcon-root"
          icon={faVial}
          width={'1em'}
        />
      }
      closeAfterFullfilled
      onClose={onClose}
      hiddenForBuyers
    />
  )
}
